import Describer from "../../../utils/issues/issue_description/describer";

function render(issue, topics) {
  const describer = new Describer.IssueDescriber(issue, topics);
  return `Both ${describer.listChildIssues} on the same clause`;
}

export default render;
